import { render, staticRenderFns } from "./SavePresetPanel.vue?vue&type=template&id=4f72b490&"
import script from "./SavePresetPanel.vue?vue&type=script&lang=js&"
export * from "./SavePresetPanel.vue?vue&type=script&lang=js&"
import style0 from "./SavePresetPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports